
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Card from "./Card.vue";

@Component({
  components: { Card }
})
export default class SideCard extends Vue {
  @Prop({ default: false })
  fullscreen!: boolean;

  /**
   * Applies absolute position to side card
   */
  @Prop({ default: false })
  absolute!: boolean;

  @Prop({ default: false })
  showGradient?: boolean;

  @Prop({ default: "100%" })
  height!: string;

  @Prop({ default: "400px" })
  width!: string;

  @Prop()
  title!: string;

  @Prop({ default: false })
  hideTitle!: string;

  @Prop()
  subtitle?: string;

  @Prop({ default: false })
  loading!: boolean;

  @Prop({ default: false })
  hideButton!: boolean;

  handleClose() {
    this.$emit("close");
  }

  get style() {
    const boxShadow = "-4px 0px 12px -2px rgba(0,0,0,0.2)";

    if (this.fullscreen) {
      return `position: fixed; top:0; right:0; bottom:0; width: ${
        this.$vuetify.breakpoint.smAndDown ? "100%" : this.width
      }; height: calc(${this.height}+64px); z-index:6; `;
    } else if (this.absolute) {
      return `
        position: fixed;
        top: 64px;
        right: 0;
        bottom: 0;
        box-shadow: ${boxShadow};
        width: ${this.$vuetify.breakpoint.smAndDown ? "100%" : this.width};
        height: ${this.height};
        z-index:6;
      `;
    } else {
      return `
        position: absolute;
        right:0;
        bottom:0;
        box-shadow: ${boxShadow};
        width: ${this.$vuetify.breakpoint.smAndDown ? "100%" : this.width};
        height: ${this.height};
        z-index:6;
      `;
    }
  }
}
